"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _DealStageIdValues = require("customer-data-objects/deal/DealStageIdValues");

var _I18n = _interopRequireDefault(require("I18n"));

var _map = _interopRequireDefault(require("transmute/map"));

var _once = _interopRequireDefault(require("transmute/once"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _translate = _interopRequireDefault(require("transmute/translate"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _sortBy = _interopRequireDefault(require("transmute/sortBy"));

var _toJS = _interopRequireDefault(require("transmute/toJS"));

var _UISearchableSelectInput = _interopRequireDefault(require("UIComponents/input/UISearchableSelectInput"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _valueSeq = _interopRequireDefault(require("transmute/valueSeq"));

var FormatDealStageOption = _interopRequireWildcard(require("customer-data-objects/deal/FormatDealStageOption"));

var getAllClosedWonOption = (0, _once.default)(function () {
  return {
    text: _I18n.default.text('customerDataObjectsUiComponents.DealStageIdSelect.allClosedWon'),
    value: _DealStageIdValues.ALL_CLOSED_WON_VALUE
  };
});
var dealStageToOptionTranslation = {
  text: FormatDealStageOption.format,
  value: 'value'
};
var dealStagesToOptions = (0, _pipe.default)(_valueSeq.default, (0, _sortBy.default)(function (stage) {
  return stage.get('displayOrder');
}), (0, _sortBy.default)(function (stage) {
  return stage.get('pipelineLabel');
}), (0, _map.default)(function (stage) {
  return (0, _translate.default)(dealStageToOptionTranslation, stage);
}), _toJS.default);
var propTypes = {
  dealStages: (0, _reactImmutableProptypes.iterableOf)((0, _reactImmutableProptypes.mapContains)({
    text: _react.PropTypes.string.isRequired,
    value: _react.PropTypes.string.isRequired
  }).isRequired),
  includeAllClosedWon: _react.PropTypes.bool.isRequired,
  isInline: _react.PropTypes.bool,
  multi: _react.PropTypes.bool.isRequired,
  readOnly: _react.PropTypes.bool,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired).isRequired])
};
var defaultProps = {
  includeAllClosedWon: false,
  menuWidth: 'auto',
  multi: false
};

var DealStageIdSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DealStageIdSelect, _PureComponent);

  function DealStageIdSelect() {
    var _this;

    (0, _classCallCheck2.default)(this, DealStageIdSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DealStageIdSelect).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      options: []
    };
    return _this;
  }

  (0, _createClass2.default)(DealStageIdSelect, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.syncOptions(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dealStages !== this.props.dealStages) {
        this.syncOptions(nextProps);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      // eslint-disable-next-line react/no-find-dom-node
      var node = (0, _reactDom.findDOMNode)(this);

      if (node) {
        node.focus();
      }
    }
  }, {
    key: "syncOptions",
    value: function syncOptions(_ref) {
      var dealStages = _ref.dealStages,
          includeAllClosedWon = _ref.includeAllClosedWon;

      if (!dealStages) {
        this.setState({
          options: []
        });
        return;
      }

      var options = dealStagesToOptions(dealStages);

      if (includeAllClosedWon) {
        options.unshift(getAllClosedWonOption());
      }

      this.setState({
        options: options
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dealStages = _this$props.dealStages,
          multi = _this$props.multi,
          readOnly = _this$props.readOnly,
          value = _this$props.value,
          isInline = _this$props.isInline,
          __includeAllClosedWon = _this$props.includeAllClosedWon,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["dealStages", "multi", "readOnly", "value", "isInline", "includeAllClosedWon"]);
      var options = this.state.options;
      var SelectComponent = multi ? _UISelect.default : _UISearchableSelectInput.default;
      var inlineStyleProps = isInline && {
        buttonUse: 'transparent',
        className: 'p-left-0'
      };
      return _react.default.createElement(SelectComponent, (0, _extends2.default)({}, rest, inlineStyleProps, {
        multi: multi || undefined,
        options: options,
        disabled: readOnly || !dealStages // if `dealStages` is undefined it might not be loaded yet so we don't
        // want to pass a value that will trip the invalid state
        ,
        value: dealStages ? value : null
      }));
    }
  }]);
  return DealStageIdSelect;
}(_PureComponent2.default);

exports.default = DealStageIdSelect;
DealStageIdSelect.propTypes = propTypes;
DealStageIdSelect.defaultProps = defaultProps;
module.exports = exports.default;